<template functional>
  <IconFA
    :icon="['fas', 'spinner-third']"
    class="text-4xl animation-spin mt-20"
    :class="[data.class, data.staticClass]"
  />
</template>


<script>
export default {};
</script>
